import { useMutation } from '@tanstack/react-query';

import { client } from '../client';

import { queryClient } from './client';

type DocumentResponse = {
  result: { documents: { url: string }[] };
};
export const getPolicyDocument = async (documentPath: string) => {
  const res = await client.get<DocumentResponse>(documentPath);
  const { documents } = res.data.result;

  if (documents.length === 0) {
    throw new Error('No documents found');
  }

  return documents[0].url;
};

export const useGetPolicyDocument = (documentPath: string) => {
  const mutationKey = ['getPolicyDocument', documentPath];

  return useMutation({
    mutationKey,
    mutationFn: async () => {
      const cachedData = queryClient.getQueryData<string>(mutationKey);
      if (cachedData) return cachedData;
      return getPolicyDocument(documentPath);
    },
    onSuccess: (data) => {
      if (data) {
        // Cache the result
        queryClient.setQueryData(mutationKey, data);
        window.open(data, '_blank');
      }
    },
  });
};
